export default __webpack_public_path__ + "static/media/hmong.672046b1.svg";